import * as aTypes from "./actionTypes";

/**
 * Routes [STEPS]
 * Step 01:  call a action function to INIT (initiate) a it.
 * > Go to: ../saga/index.js
 */
export const initFetchActivities = (user_id) => {
  return {
    type: aTypes.ACTIVTS_INIT,
    id: user_id,
  };
};

/**
 * Routes [STEPS]
 * Step 04: This action will redirect to a reducer with a object with  type and data
 * > Go to: ../reducers/activities.js
 */
export const setActivities = (activities) => {
  return {
    type: aTypes.ACTIVTS_SET,
    activities: activities,
  };
};

export const fetchActivitiesFailed = (activities_error) => {
  return {
    type: aTypes.ACTIVTS_FAIL,
    activities_error: activities_error,
  };
};

export const setFiltredActivities = (filteredActivities) => {
  return {
    type: aTypes.ACTIVTS_FILTRED_SET,
    filteredActivities: filteredActivities,
  };
};
